import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import { compose, withProps } from 'recompose';
import { OrderStateSelect, IOrderStateSelectProps } from './OrderStateSelect';

const GetOrderStateListQuery = gql`
  query ($domain: String!) {
    externalOrderStates(where: { eshop: { domain: $domain } }) {
      id
      title
      type
      priority
      color
      name
      startup
    }
  }
`;

export default withRouter(compose<{}, IOrderStateSelectProps>(
  graphql<IOrderStateSelectProps, any>(GetOrderStateListQuery, {
    name: 'orderStates',
    options: props => ({
      variables: {
        domain: props.match.params.eshop
      }
    })
  }),
  withProps(({ orderStates }: any) => {
    return {
      orderStates: orderStates.externalOrderStates,
    };
  }),
)(OrderStateSelect));



// WEBPACK FOOTER //
// ./src/components/Others/OrderStateSelect/index.ts